<template>
    <tbody>
        <tr v-for="(period, key) in periods.periods" :key="key">
            <th>{{ key | monthYear }}</th>
            <td v-for="day in 31" :key="`${key}-${day}`" :class="{'td-insertion': checkExists(period, day)}">
                <v-sheet v-if="checkExists(period, day)" color="primary" class="-date-insertion" :class="{'complement': period[`D-${day}`].complement, 'first': period[`D-${day}`].firstDate, 'last': period[`D-${day}`].lastDate }">
                    {{ getCellValue(period[`D-${day}`]) }}
                </v-sheet>
            </td>
        </tr>
    </tbody>
</template>

<script>
import moment from 'moment'
    export default {
        name: "QuotationCalendarPeriods",
        props: {
            order: Object
        },
        watch: {
            'order.periods': {
                handler() {
                    this.$nextTick(() => {
                        const v = this.periods
                        this.$emit('update-totalizers', {
                            totalPeriods: v.countDistinctDates.length, 
                            totalInsertions: v.insertionsTotal
                        })
                    })
                }
            }
        },
        mounted(){
            this.$nextTick(() => {
                const v = this.periods
                this.$emit('update-totalizers', {totalPeriods: v.countDistinctDates.length, totalInsertions: v.insertionsTotal  })
            })
        },
        computed: {
            formulaBase() {
                return this.order?.asuFormat?.asus?.formula?.base || ''
            },
            formulaHasQ() {
                return this.formulaBase.includes('Q')
            },
            formulaHasI() {
                return this.formulaBase.includes('I')
            },
            periods(){
                const order = this.order
                const res = {
                    countDates: [],
                    countTotalDates: [],
                    countDistinctDates: [],
                    countTotalDistinctDates: [],
                    insertionsTotal: 0,
                    periods: {}
                }
                if(!order || !order.periods || !order.periods.length) return res
                const result = {}
                const allPeriods = []
                const periodicity = order.asuFormat?.asus?.periodicity
                const computeLastDate = (period) => {
                    if (periodicity) {
                        const start = moment(period.startAt)
                        if (periodicity.type === 'D') return start.add(periodicity.value - 1, 'days')
                        if (periodicity.type === 'W') return start.add(periodicity.value * 7 - 1, 'days')
                        if (periodicity.type === 'M') return start.add(periodicity.value, 'months').subtract(1, 'day')
                    }
                    return moment(period.endAt).subtract(1, 'day')
                }
                order.periods.forEach((period) => {
                    if (!moment(period.startAt, ['YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss'], true).isValid()) return
                    let firstDate = moment(period.startAt)
                    res.countDates.push(firstDate.format('YYYY-MM-DD'))
                    res.countTotalDates.push(firstDate.format('YYYY-MM-DD'))
                    let lastDate = computeLastDate(period)
                    if(!allPeriods.includes(firstDate.format('YYYY-MM'))){
                        allPeriods.push(firstDate.format('YYYY-MM'))
                        result[firstDate.format('YYYY-MM')] = {}
                    }
                    result[firstDate.format('YYYY-MM')][`D-${firstDate.format('D')}`] = {...period, complement: false, firstDate: true}
                    res.insertionsTotal += period.insertions
                    const totalDays = Math.abs(lastDate.diff(firstDate, 'days'))
                    if(totalDays === 0) {
                        result[firstDate.format('YYYY-MM')][`D-${firstDate.format('D')}`].lastDate = true
                    } else {
                        const startDate = moment(period.startAt)
                        for(let i = 1; i <= totalDays; i++){
                            const diffDate = moment(startDate).add(i, 'days')
                            const diffMonth = diffDate.format('YYYY-MM')

                            if(!allPeriods.includes(diffMonth)){
                                allPeriods.push(diffMonth)
                                result[diffMonth] = {}
                            }

                            res.countTotalDates.push(diffDate.format('YYYY-MM-DD'))
                            const isMonthStart = diffDate.format('D') === '1'
                            result[diffMonth][`D-${diffDate.format('D')}`] = {
                                ...period,
                                complement: true,
                                firstDate: false,
                                lastDate: i === totalDays,
                                insertions: isMonthStart ? period.insertions : null,
                                quantity: isMonthStart ? period.quantity : null,
                            }
                        }
                    }

                })
                res.countDistinctDates = res.countDates.filter((item, pos) => { return res.countDates.indexOf(item) == pos})
                res.countTotalDistinctDates = res.countTotalDates.filter((item, pos) => { return res.countDates.indexOf(item) == pos})
                res.periods = result
                return res
            }
        },
        methods: {
            checkExists(period, day){
                return period && period.hasOwnProperty(`D-${day}`)
            },
            getCellValue(cell) {
                if (!cell) return ''
                const hasQ = this.formulaHasQ
                const hasI = this.formulaHasI
                if (hasQ && hasI) {
                    const q = cell.quantity != null ? cell.quantity : ''
                    const i = cell.insertions != null ? cell.insertions : ''
                    if (q === '' && i === '') return ''
                    return `${q} | ${i}`
                }
                if (hasQ) return cell.quantity != null ? cell.quantity : ''
                return cell.insertions != null ? cell.insertions : ''
            }
        }
    }
</script>
<style lang="scss">
td.td-insertion {
    padding: 0 !important;
}
.-date-insertion{
    text-align: center;
    color: #fff !important;
    margin: 0 !important;
    min-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.first{
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        margin-left: 4px !important;
    }
    &.last{
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        margin-right: 4px !important;
    }
}
</style>